import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Observable } from 'rxjs';
import { CampaignModel } from 'src/app/models/campaigns.model';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { InventoryService } from 'src/app/services/inventory.service';
import Swal from 'sweetalert2';
import {map, startWith} from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { UsersService } from 'src/app/services/users.service';
import * as XLSX from 'xlsx';


interface Material {
  id: number;
  nombre: string;
  id_m: number;
  storage?: { perc: number, qty: number, rec: number };
  sku: string;
  tipo: string;
}

@Component({
  selector: 'app-inventario',
  templateUrl: './inventario.component.html',
  styleUrls: ['./inventario.component.scss']
})
export class InventarioComponent {

  campaignList = new Array<CampaignModel>();
  selectedCampaign: number = 0;
  materials: Material[] = [];
  imageSrc: string = '';
  tipoRecepcion: string = 'Cantidad';
  selectedSku: string = '';
  cantidad: number = 0;
  cantidadDanado: number = 0;
  tooltipMat: boolean = false;
  toggleCalcularPeso: boolean = false;
  toggleDanados: boolean = false;
  lblPesoUnitario: string = '';
  lblUnidades: string = '';
  selectedMatNombre = '';
  esperado: number = 0;
  recibido: number = 0;
  pendiente: number = 0;
  utilizado: number = 0;
  actual: number = 0;
  en_linea: number = 0;
  danados: number = 0;
  selectedTipo: string = '';
  historial: {fecha: Date, descripcion: string, cantidad: number, usuario: string}[] = [];
  porcentaje: number = 0;
  selectedIdMaterial: number = 0;
  selectedIdM: number = 0;
  peso: number = 0;
  unidades: number = 0;
  materialControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions!: Observable<Material[]>;
  loading: boolean = false;

  constructor(
    private inventoryServ: InventoryService,
    private campService: CampaignsService,
    private userS: UsersService,
  ) { }

  ngOnInit(): void {
    this.getInitialData();
    
  }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.userS.hasPermissions(key, buho, client);
  }

  getInitialData() {
    this.campService.getCampaingList().subscribe(
      (result: any) => {
        this.campaignList = result;
      },
      (err: any) => {
        console.log(err);

      }
    );
  }

  onSelectedCamp(event: MatSelectChange) {
    //Reestablecer campos
    this.materials = [];
    this.materialControl.setValue(''); 
    this.toggleCalcularPeso = false;
    this.toggleDanados = false;
    this.cantidad = 0;
    this.changeLabelsPeso();
    this.selectedMatNombre = '';
    this.selectedIdMaterial = 0;
    this.esperado = 0;
    this.recibido = 0;
    this.pendiente = 0;
    this.utilizado = 0;
    this.actual = 0;
    this.en_linea = 0;
    this.danados = 0;
    this.porcentaje = 0;
    this.historial = [];
    this.imageSrc = '';

    this.selectedCampaign = event.value;
    this.tooltipMat = true;
    this.getMaterialsCampaign();
  }

  async getMaterialsCampaign() {
    this.loading = true;
    this.inventoryServ.getMaterialsCampaign(this.selectedCampaign).subscribe(
      (result: any) => {
        this.materials = result.data as Material[];
        this.initMatSelect();
        this.getMaterialsSummary();
      },
      (err: any) => {
        console.log(err);

      }
    );
  }

  onSelectedMat(event: MatAutocompleteSelectedEvent): void {

    const selectedMaterial: Material = event.option.value;

    this.selectedSku = selectedMaterial.sku;
    this.selectedMatNombre = selectedMaterial.nombre;
    this.selectedTipo = selectedMaterial.tipo;
    this.selectedIdMaterial = selectedMaterial.id;
    this.selectedIdM = selectedMaterial.id_m
    this.materialInfo()
    
  }

  materialInfo(){
    this.inventoryServ.getMaterialInfo(this.selectedIdMaterial, this.selectedCampaign, this.selectedIdM, this.selectedTipo).subscribe(
      (result: any) => {
        
        this.cantidad = 0;
        this.imageSrc = result.image?.img;
        this.esperado = result.info?.cantidad;
        this.recibido = result.info?.recibido;
        this.pendiente = this.esperado - this.recibido;
        this.utilizado = result.info?.empacado;
        this.actual = this.recibido - this.utilizado;
        this.en_linea = result.info?.en_linea;
        this.danados = result.info?.danado;
        this.historial = result.historial;
        this.peso = result.info?.peso;
        
        this.porcentaje = parseFloat(((this.recibido * 100) / this.esperado).toFixed(2));
        this.toggleCalcularPeso = false;
        this.toggleDanados = false;
        this.changeLabelsPeso();
        
      },
      (err: any) => {
        console.log(err);

      }
    );
  }

  validationForm() {

    if (this.selectedCampaign == 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Debe seleccionar una campaña',
        confirmButtonText: 'Ok',
      });
    }
    else if (this.selectedIdMaterial == 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Debe seleccionar un material',
        confirmButtonText: 'Ok',
      });
    }
    else if (!Number.isInteger(this.resultadoSuma) && !this.toggleCalcularPeso) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'El resultado debe ser un número entero',
        confirmButtonText: 'Ok',
      });
    }
    else if (this.cantidad == 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Cantidad a ingresar debe ser diferente de 0',
        confirmButtonText: 'Ok',
      });
    }
    else {
      Swal.fire({
        title: "Atención",
        text: "¿Seguro que deseas guardar esta información?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          this.saveData();
        }
      });
    }
    
  }

  saveData() {

    if(this.toggleCalcularPeso){
      this.cantidad = Math.round(this.unidades);
    }
    if(this.toggleDanados){
      this.cantidadDanado = this.cantidad;
      this.cantidad = 0;
    }
    let objData = {
      campaign: this.selectedCampaign,
      sku: this.selectedSku,
      cantidad: this.cantidad,
      danado: this.cantidadDanado,
      tipo: this.selectedTipo,
      recibido: this.recibido,
      utilizado: this.utilizado,
      id: this.selectedIdMaterial,
      idM: this.selectedIdM
    }
    this.inventoryServ.setInventario(objData).subscribe(
      (result: any) => {
        Swal.fire({
          icon: 'success',
          title: 'Guardado',
          text: ''
        });
        this.materialInfo();

      },
      (err: any) => {
        console.log(err);

      }
    );
  }


  onChangeCalcularPeso(event: Event){

    const proximoEstado = this.toggleCalcularPeso;

    if(this.peso == 0 && proximoEstado){
      this.toggleCalcularPeso = false;
      event.preventDefault();
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'No se puede calcular por peso, ya que este material no tiene un peso unitario',
        confirmButtonText: 'Ok',
      }).then(() => {
        this.toggleCalcularPeso = false;
      });
      return;
    }
    else{
      this.changeLabelsPeso();
    }

  }

  changeLabelsPeso(){
   if(this.toggleCalcularPeso){
      this.tipoRecepcion = 'Peso (Kg)'
      this.lblPesoUnitario = 'Peso Unitario: ' + this.peso + ' (Kg)';
      this.unidades = this.peso * this.cantidad;
      this.lblUnidades = '= ' + this.unidades + ' unidades';
    }
    else{
      this.tipoRecepcion = 'Cantidad'
      this.lblPesoUnitario = ''
      this.lblUnidades = ''
    }
  }

  get resultadoSuma(): number {
    if(this.toggleCalcularPeso){
      if(this.toggleDanados){
        return this.actual;
      }
      else{
        return Number(Math.round( (this.cantidad * 10) / (this.peso * 10))) + this.actual;
      }
    }
    else{
      if(this.toggleDanados){
        return this.actual;
      }
      else{
        return Number(this.cantidad) + this.actual;
      }
    }
  }

  get resultadoUnidades(): string {
    if(this.toggleCalcularPeso){
      this.unidades = Math.round( (this.cantidad * 10) / (this.peso * 10));
      return  '= ' + this.unidades + ' unidades';
    }
    else{
      return '';
    }
  }

  get resultadoCantidad(): number {
    if(this.toggleCalcularPeso){
      return Number(Math.round( (this.cantidad * 10) / (this.peso * 10)));
    }
    else{
      return Number(this.cantidad);
    }
  }

  // Muestra el nombre del objeto cuando ha sido seleccionado
  displayFn(material: Material): string {
    return material && material.nombre ? material.nombre : '';
  }

  // Función de filtrado adaptada para objetos
  private _filter(value: string): Material[] {
    const filterValue = value.toLowerCase();

    return this.materials.filter(material => 
      // Aquí comparamos la propiedad 'nombre' del objeto con el texto del input
      material.nombre.toLowerCase().includes(filterValue)
    );
  }

  initMatSelect(){
    this.filteredOptions = this.materialControl.valueChanges.pipe(
      startWith(''), 
      map(value => {
        const name = typeof value === 'string' ? value : value?.nombre || ''; 
        return name ? this._filter(name as string) : this.materials.slice();
      })
    );
  }

  clearAutocomplete(event?: Event) {
    if (event) {
        event.stopPropagation();
    }
    this.materialControl.setValue(null);
    this.toggleCalcularPeso = false;
    this.toggleDanados = false;
    this.cantidad = 0;
    this.changeLabelsPeso();
    this.selectedMatNombre = '';
    this.selectedIdMaterial = 0;
    this.esperado = 0;
    this.recibido = 0;
    this.pendiente = 0;
    this.utilizado = 0;
    this.actual = 0;
    this.en_linea = 0;
    this.danados = 0;
    this.porcentaje = 0;
    this.historial = [];
    this.imageSrc = '';
  }

  /** Regresa el nombre de la campaña según su ID.
    * @param {number} ID El ID de la campaña.
    * @returns {string} El nombre de la campaña. */
  campaignName(ID: number): string {
    const x: CampaignModel | undefined = this.campaignList.find((x: CampaignModel) => x.id == ID);
    return (x?.name ?? 'la campaña');
  }

  downloadMatSummary(): void {
    const filename = 'materiales_' + this.campaignName(this.selectedCampaign).toLocaleLowerCase().replace(/\s+/g, "_");
    
    // Create data
    const data: Array<{ Nombre: string, Recibidos: number, Esperados: number, Porcentaje: number }> = this.materials.map(x => {
      let perc: number = (x.storage?.rec ?? 0)/(x.storage?.qty || 1);
      if (perc > 1) perc = 1;
      return { Nombre: x.nombre, Recibidos: x.storage?.rec ?? 0, Esperados: x.storage?.qty ?? 0, Porcentaje: perc };
    });

    // Create worksheet
    const WS: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Format the last column for percentage values
    for (let i = 2; i <= data.length + 1; i++) {
      const cell = WS[`D${i}`];

      if (cell) {
        cell.t = "n";
        cell.z = "0.00%";
      }
    }

    // Create workbook
    const WB: XLSX.WorkBook = XLSX.utils.book_new();

    // Append data
    XLSX.utils.book_append_sheet(WB, WS, 'Resumen');

    // Generate XLSX buffer
    const buffer = XLSX.write(WB, {
      bookType: "xlsx",
      type: "array"
    });

    // Create BLOB
    const blob: Blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    // Create temporary download link
    const url: string = window.URL.createObjectURL(blob);

    const anchor: HTMLAnchorElement = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;

    document.body.appendChild(anchor);
    anchor.click();

    // Cleanup
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }

  /** Regresa el nombre del status actual del material de acuerdo con su porcentaje.
    * @param {number} perc El porcentaje actual del material.
    * @returns {string} El nombre de la clase/status. */
  materialColor(perc: number): string {
    if (perc < 20) return '#D22042';
    else if (perc < 60) return '#FFC752';
    else if (perc < 100) return '#00C853';
    return '#235394';
  }

  /** Recibe y actualiza los porcentajes con base en el resumen recibido de la base de datos. */
  async getMaterialsSummary() {
    const data: Map<number, { rec: number, qty: number }> = await this.inventoryServ.getMaterialsSummary(this.selectedCampaign);

    for (const x of this.materials) {
      const i: { rec: number, qty: number } | undefined = data.get(x.id);
      x.storage = (i !== undefined) ?
        { perc: parseFloat(((i.rec * 100) / (i.qty || 1)).toFixed(0)), qty: i.qty, rec: i.rec } :
        { perc: 0, qty: 0, rec: 0 };

      if (x.storage.perc > 100)
        x.storage.perc = 100;
    }

    this.loading = false;
  }
}